<template>
  <myhead @next="next">{{$route.meta.title}}</myhead>

  <div class="center pad40" v-if="null!=status">
    <div v-if="status==1">
      <div class="BGon Cfff opacity5 height50px width50px mt50 radius50 auto flex cen size32"><van-icon name="success" /></div>
      <p class="b500 mt20 mb80">您已成功支付</p>
    </div>
    <div v-if="status==2">
      <div class="BGred Cfff opacity5 height50px width50px mt50 radius50 auto flex cen size32"><van-icon name="cross" /></div>
      <p class="b500 mt20 mb80">支付失败</p>
    </div>
    <van-button type="primary" round block @click="next">返回上一页</van-button>
    <!-- <van-button class="mt15" round block v-if="status==2" @click="playAlery=true">重新支付</van-button> -->
  </div>

</template>

<script>
export default {
  name: 'Status',
  data(){
    return {
      status:null  // 1支付成功
    }
  },
  methods:{
    next(){
      if(this.$store.state.loginInfo.token){
        this.$router.replace({path:'/me'})
      }else if(this.$route.path!='/sense/status'){
        this.$router.back();
      }else{
        if(this.status==1){
          this.$router.replace({path:'/register',query:{...this.$router.query,loginStatus:2}})
        }else if(this.status==2){
          this.$router.replace({path:"/sense",query:{column_type:0}})
        }
      }
    },
    getDetail(){
      this.ajax.post("/pay/payresult",{no:this.$route.query.no}).then(({data})=>{
        if(!data){ return }
        this.$store.state.loginInfo.id = data.id;
        localStorage.setItem("loginInfo",JSON.stringify(this.$store.state.loginInfo));
        if(data.pay_status==1){
          return this.status = 2
        }
        this.status = 1
      }).catch(()=>{
        this.status = 2
      })
    }
  },
  created(){
    this.getDetail();
    if(!this.$store.state.loginInfo.token){
      this.$store.state.loginStatus = 2;
    }
    
  }
}
</script>

<style>
</style>
